exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Typing__letter_hidden{visibility:hidden}.Typing__letter_space{display:inline-block;width:.3em;overflow:hidden;text-decoration:inherit}.Typing__letter_color_green{color:#94ab45}.Typing__letter_color_blue{color:#2d5da5}.Typing__letter_color_orange{color:#da9d26}.Typing__letter_color_red{color:#a33c53}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../src/components/typing/index.scss
// module id = 781
// module chunks = 0